module.exports = __webpack_public_path__ + "static/media/logo-bnkk@2x.3a459d75.png";